module.exports = __webpack_public_path__ + "static/media/enterprise-shipping-1.aeeeb5f9.png";